import BaseAPI from "./BaseAPI";

class CustomerAPI extends BaseAPI {
	
    get = async (customerId = null) => {
        var promise = null;
        if(!customerId) {
            promise = await this.init().get("/account/customer");
        } else if(customerId) {
            promise = await this.init().get("/account/customer/"+customerId);
        }
        return promise;
    };


	
	getFiles = async () => {
		var promise = await this.init().get("/account/files");
		return promise;
	};

	downloadFile = async () => {
		var promise = await this.init().get("/account/downloadFile");
		return promise;
	};

	deleteFile = async (file) => {
		var promise = await this.init().delete("/account/deleteFile/"+file.key);
		return promise;
	};

    addFileDescription = async (fileId, description) => {
        var promise = await this.init().post("/account/file/"+fileId, {description:description});
        return promise;
    };

	storeCustomer = async (data) => {
        let dataObj = data
        if(data.toJsonString) {
            dataObj = data.toJsonString();            
        }
		var promise = await this.init().post("/account/customer", dataObj);
		return promise;
	};

    storeCompany = async (data) => {
        let dataObj = data
        var promise = await this.init().post("/account/company", dataObj);
        return promise;
    };

    deleteCustomer = async (customerKey) => {
        var promise = await this.init().delete("/account/customer/"+customerKey);
        return promise;
    };

    checkKvK = async (data) => {
        let dataObj = data;
        var promise = await this.init().post("/account/customer/kvkcheck", dataObj);
        return promise;
    };


	
}

export default new CustomerAPI();